import {
    RESET,
    SET_ERRORS,
    SET_EDIT_MODAL,
    SET_DOCUMENT,
    SET_GAZETTES,
    SET_GAZETTE, SET_SHOW_MODAL, SET_DOCUMENT_LOADING,
} from '../../utils/constants'

const initialState = () => ({
    headers: [
        {
            text: "Művelet",
            value: "description",
            sortable: false,
            divider: true,
        },
        {
            text: "Módosító",
            value: "causer_name",
            divider: true
        },
        {
            text: "Típus",
            value: "subject_type",
            divider: true
        },
        {
            text: "Dátum",
            value: "created_at",
            divider: true
        },
        {
            text: "Régi érték",
            value: "old",
            sortable: false,
            divider: true
        },
        {
            text: "Új",
            value: "new",
            sortable: false,
            divider: true
        },
        {
            text: "Lehetőségek",
            value: "actions",
            sortable: false
        }
    ],
    document: {
        metas: {},
        is_public: true,
        is_archiv: false,
        is_incognito: false,
        valid_until_revoked: false,
        files: [],
        issuer: {}
    },
});

const state = {
    ...initialState(),
    documents: [],
    gazettes:[],
    issuers: []
};

const getters = {};

Object.keys(state).forEach(key => {
    Object.assign(getters, {
        [key]: state => state[key]
    });
});

const actions = {
    reset({commit}) {
        commit(RESET);
    },
    getGazettes({state, rootGetters, dispatch, commit}) {
        axios({
            method: "GET",
            url: "gazette",
            params: rootGetters["Table/params"]
        }).then(response => {
            state.gazettes = response.data.data

            dispatch("Table/rowsLoaded", {...response.data.meta}, {root: true});
        }).finally(()=> commit(SET_DOCUMENT_LOADING, false));
    },
    getDocuments({state, rootGetters, dispatch}) {
        axios({
            method: "GET",
            url: "gazette",
            params: rootGetters["Table/params"]
        }).then(response => {
            state.documents = response.data.data;

            dispatch("Table/rowsLoaded", {...response.data.meta}, {root: true});
        });
    },
    async getDocumentById({state, commit}, id) {
        try {
            const response = await axios(`documents/${id}`);

            state.document = response.data.data;

            commit(`Modal/${SET_EDIT_MODAL}`, true, {root: true});
        } catch (error) {
            commit(SET_ERRORS, error, {root: true});
        }
    },
    loadOldDocument({ commit, state },document) {
        const gazettes = state.gazettes;
        const issuer_id = document.old.issuer_id??document.new.issuer_id;
        axios(`issuers/${issuer_id}`).then(response => {
            document.old.issuer = response.data.data;
            document.new.issuer = response.data.data;
            document.issuer = response.data.data
            commit(`Document/${SET_DOCUMENT}`,document.old.issuer_id?document.old:document.new, {root:true});
            commit(`Modal/${SET_SHOW_MODAL}`, true, {root: true})
        }).finally(()=>{
            commit(SET_GAZETTES, gazettes);
        })
    },
    getAllIssuers({state}) {
        axios("all/issuers").then(response => {
            state.issuers = response.data.data;
        });
    },
};

const mutations = {
    [RESET](state) {
        Object.assign(state, initialState());
    },
    [SET_DOCUMENT](state, payload) {
        state.document = {...payload};
    },
    [SET_GAZETTES](state, payload) {
        state.gazettes = payload;
    },
    [SET_GAZETTE](state, payload) {
        state.gazette = {...payload};
    },
    [SET_DOCUMENT_LOADING](state, payload) {
        state.loading = !!payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
